import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import CreditCard from '@icons/paymentMethod/CreditCard';

import styles from './styles.module.scss';

function PaymentMethod() {
  return (
        <Column as='section'
                className={styles.container}
                spacing={24} >
            <Text fontWeight='bold' size='2xl' color={colors.gray7}>
                결제 수단
            </Text>
            <div>
                <Column align='center' spacing={8} >
                    <CreditCard size={52} color={colors.primary} />
                    <Text fontWeight='bold'>신용카드</Text>
                </Column>
            </div>
        </Column>
  );
}

export default PaymentMethod;
